const baseURL = process.env.REACT_APP_CHAT_SERVER_URL

export const conversationURL = `${baseURL}/conversations`
export const participantsURL = `${baseURL}/participants`
